import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorHandler, HandleError } from '../http-error-handler.service';

import { Config } from '../config';
import { DewAuthService } from 'src/authentication/core/auth.service';

const mimeTypes = {
  pdf: 'application/pdf',
  png: 'image/png',
  jpeg: 'image/jpeg',
  bmp: 'image/bmp',
  ppm: 'image/x-portable-pixmap',
  gif: 'image/gif',
};

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private handleError: HandleError;

  private httpOptions = null;
  constructor(
    private http: HttpClient,
    private authService: DewAuthService,
    httpErrorHandler: HttpErrorHandler,
    private sanitizer: DomSanitizer
  ) {
    this.handleError = httpErrorHandler.createHandleError('ApiService');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: this.authService.authToken,
      }),
    };
  }

  getusersofapp(gridProperties, uesr): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/getusersofapp';

    var request: any = {};

    request.gridProperties = gridProperties;

    request.uesr = uesr;

    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('getusersofapp', request)));
  }

  InserAppUser(request): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/InserAppUser';
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('InserAppUser', request)));
  }

  getCountries(): Observable<any> {
    var url = Config.ServiceBaseUrl + "api/getAllCountry";
    var request: any = {};
    return this.http
      .post(url, request)
      .pipe(catchError(this.handleError("getAllCountry", request)));
  }

  getStatesByCountry(id): Observable<any> {
    var url = Config.ServiceBaseUrl + "api/getAllStatesByCountry";
    var request: any = {};
    request.countryId = id;

    return this.http
      .post(url, request)
      .pipe(catchError(this.handleError("getAllStatesByCountry", request)));
  }

  getCityByState(id): Observable<any> {
    var url = Config.ServiceBaseUrl + "api/getAllCityByStates";
    var request: any = {};
    request.stateId = id;

    return this.http
      .post(url, request)
      .pipe(catchError(this.handleError("getAllCityByStates", request)));
  }

  updateAppUser(request): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/updateAppUser';
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('updateAppUser', request)));
  }

  deleteAppUser(request): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/deleteAppUser';
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('deleteAppUser', request)));
  }

  addAppuserCustom(uesr): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/addAppuserCustom';
    var request: any = {};

    request.uesr = uesr;

    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('addAppuserCustom', request)));
  }

  /**
   * RESOURCE PROJECT
   */

  getMySchedule(myScheduleReq): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/getMySchedule';
    var request: any = {};
    request = myScheduleReq;

    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('getMySchedule', request)));
  }

  updateTaskByTaskId(request): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/updateResourceTask';
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('api/updateResourceTask', request)));
  }

  createResourceTask(request): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/createResourceTask';
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('api/createResourceTask', request)));
  }

  getAllProjects(gridProperties): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/getAllProjects';
    var request: any = {};
    request.gridProperties = gridProperties;

    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('api/getAllProjects', request)));
  }

  getAllTasksByProjectId(projectGetId): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/getAllTasksByProjectId';
    var request: any = {};
    request.projectGetId = projectGetId;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('api/getAllProjects', request)));
  }

  getCurrentTasksByProject(projectGetId, resourceGetId): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/getCurrentTasksByProjectId';
    var request: any = {};
    request.projectGetId = projectGetId;
    request.resourceGetId =resourceGetId;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('getAllTasksByProjectId', request)));
  }

  getDepartmentSchedule(departmentReq): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/getDepartmentSchedule';
    var request: any = {};
    request = departmentReq;

    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('getDepartmentSchedule', request)));
  }

  //Roles And Access Management
  addEntityOperation(requestInput): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/addEntityOperation';
    var request: any = {};
    request = requestInput;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('addEntityOperation', request)));
  }

  getEntityOperation(gridProperties): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/getAllEntityOperation';
    var request: any = {};
    request.gridProperties = gridProperties;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('getAllEntityOperation', request)));
  }

  
  getMasterClientLogoByDomainName(requestName): Observable<any> {
    var url = Config.ServiceBaseUrl + "api/getMasterClientLogoByDomainName";
    var request: any = {};
    request.requestName = requestName;

    return this.http
      .post(url, request)
      .pipe(catchError(this.handleError("api/getClientLogoByDomainName", request)));
  }

  deleteEntityOperation(requestInput) {
    var url = Config.ServiceBaseUrl + 'api/deleteEntityOperation';
    var request: any = {};
    request = requestInput;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('deleteEntityOperation', request)));
  }

  deleteResourceTask(resourceTaskGetId) {
    var url = Config.ServiceBaseUrl + 'api/deleteResourceTask';
    var request: any = {};
    request.resourceTaskGetId = resourceTaskGetId;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('deleteResourceTask', request)));
  }

  getUserByDepartment(departmentGetId): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/getUserByDepartment';
    var request: any = {};
    request.departmentGetId = departmentGetId;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('getUserByDepartment', request)));
  }

  getUserByDepartmentIds(haveAccessToEveryone, departmentGetId, userGetId, resourceStatus): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/getUserByDepartmentIds';
    var request: any = {};
    request.haveAccessToEveryone = haveAccessToEveryone;
    request.departmentGetId = departmentGetId;
    request.userGetId = userGetId;
    request.isActive = resourceStatus;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('getUserByDepartmentIds', request)));
  }

  createResourceTaskTimeOff(request): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/createResourceTaskTimeOff';
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('createResourceTaskTimeOff', request)));
  }

  updateResourceTaskTimeOff(request): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/updateResourceTaskTimeOff';
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('updateResourceTaskTimeOff', request)));
  }
}
